import { useMemo } from 'react';
import { getMonth, getYear } from 'date-fns';

import { Quarter } from '../../../types';
import { RangeIntervalTypes } from '../../components/RangeIntervalPicker/utils';
import locales from './locales';

const getQuarter = (intervalStartDate: Date): Quarter => {
  const i = Math.floor(getMonth(intervalStartDate) / 3);
  // @ts-expect-error Type 'Quarter | undefined' is not assignable to type 'Quarter'.
  return Object.values(Quarter)[i];
};

const useDateLabel = (
  intervalStartDate: Date | undefined,
  type: RangeIntervalTypes,
) => {
  const label: string = useMemo(() => {
    if (!intervalStartDate) {
      return '';
    }

    switch (type) {
      case 'month':
        return new Intl.DateTimeFormat(locales.dateFormat, {
          month: 'long',
          year: 'numeric',
        }).format(intervalStartDate);
      case 'year':
        return getYear(intervalStartDate).toString();
      case 'quarter':
        return locales
          .formatString(locales.quarter[getQuarter(intervalStartDate)], {
            year: getYear(intervalStartDate),
          })
          .toString();
      default:
        return locales.custom;
    }
  }, [intervalStartDate, type]);

  return label;
};

export default useDateLabel;
